<template>
  <v-card height="275px" width="550px">
    <v-card-title>
      <v-row class="text-center">
        <v-col align-self="center">
          Nueva orden de {{(projectInfo.type === "buy")?"compra":"venta"}}
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text >
      <v-row class="mx-2" >
        <v-col cols="2" class="text-center">
          {{projectInfo.name}}
        </v-col>
        <v-col cols="3" class="text-right">
          Máx. compra: 
        </v-col>
        <v-col cols="2" class="text-left">
          {{buyOrderTop ? buyOrderTop.price : '--'}} {{projectInfo.currency}}
        </v-col>
        <v-col cols="3" class="text-right">
          Máx. venta: 
        </v-col>
        <v-col cols="2" class="text-left">
          {{sellOrderTop ? sellOrderTop.price : '--'}} {{projectInfo.currency}}
        </v-col>
      </v-row>
      <v-form ref="form">
        <v-row align="center" justify="center" class="text-center">
          <v-col cols="1"/>
          <v-col cols="3" class="text-right">
            Cantidad: 
          </v-col>
          <v-col cols="2" class="text-left">
            <v-text-field
              v-model="credits"
              type="number"
              :rules="creditsRules()"
            />
          </v-col>
          <v-col cols="3">
            Precio {{(projectInfo.type == "buy")?"max.":"min."}}
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="price"
              type="number"
              :rules="priceRules()"
            />
          </v-col>
          <v-col cols="1"/>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-row align="center" justify="center" class="text-center">
        <v-col cols="6">
          <v-btn
            @click="placeOrder"
            class="primary"
          > Crear
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            @click="cancel"
            class="primary"
          > Cancelar
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props:{
    params:{
      type:Object,
      default: ()=> {
        return {
          projectInfo:undefined
        }
      }
    }
  },
  data(){
    return {
      credits:0,
      price:0.0,
      projectInfo:{
        id:0,
        name:"",
        profitPercentage:0,
        currency:"",
        buy:""
      },
      buyOrderTop: undefined,
      sellOrderTop: undefined
    }
  },
  mounted(){
    this.projectInfo = this.params.projectInfo
    this.$cf_api.getProjectTops(this.projectInfo.id).then(r=> {
      this.buyOrderTop = r.data[0]
      this.sellOrderTop = r.data[1]
    })
  },
  watch:{
    credits:'validateField',
    price:'validateField'
  },
  methods:{
    validateField(){
      this.$refs.form.validate();
    },
    printDate(date){
      let dateStr = new Date(date)
      return dateStr.toLocaleDateString()
    },
    placeOrder(){
      this.$cf_api.createNewOrder({
        credits:parseFloat(this.credits),
        price: parseFloat(this.price),
        projectId: this.projectInfo.id,
        userName: this.$store.getters.oidcUser.name,
        orderType: this.projectInfo.type,
        orderId: this.projectInfo.orderId
      }).then(r=>{
        var snacktext= 'Orden de ' 
        if(this.projectInfo.type==='buy'){
          snacktext+='compra creada.'
        } else { 
          snacktext+='venta creada.'
        }
        if(r.data.creditsTransactioned !==0){
          if(parseInt(this.credits)===r.data.creditsTransactioned){
            snacktext+= ' <br/> Orden completada automaticamente.'
          } else {
            snacktext+= ' <br/> Orden parcialmente completada: <br/>  - Créditos transaccionados: ' + r.data.creditsTransactioned + '<br/> - Créditos restantes para completar orden: ' + this.credits
          }
        }
        this.$store.dispatch('setSnackFeedback', {text: snacktext, timeout: -1})
        this.$emit('closed')
      }).catch(e=> {
        console.log('Error creating new order: ',e)
      })
    },
    cancel(){
      this.$emit('closed')
    },
    creditsRules(){
      var rules= [
        v=> v!==0 || 'Valor requerido'
      ]
      if(this.projectInfo.type==='sell'){
        rules.push(v=> v < this.projectInfo.creditsAvailable || 'Valor mayor a créditos disponibles')
      }
      return rules;
    },
    priceRules(){
      var rules= [
        v=> v!==0 || 'Valor requerido'
      ]
      if(this.projectInfo.type==='buy'){
        rules.push( v=> (v * this.credits) < this.$store.getters.getUserAccounts.accounts[0].balance || 'Total de compra supera dinero disponible.')
      }
      return rules;
    }
  }
}
</script>